import { render, staticRenderFns } from "./campaignsNumbers.vue?vue&type=template&id=599ea034&scoped=true"
import script from "./campaignsNumbers.vue?vue&type=script&lang=js"
export * from "./campaignsNumbers.vue?vue&type=script&lang=js"
import style0 from "./campaignsNumbers.vue?vue&type=style&index=0&id=599ea034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599ea034",
  null
  
)

export default component.exports